// extracted by mini-css-extract-plugin
export var root = "_23565798883973c6c1ef5e42b8822632-css";
export var linkButton = "_024bf63d3df99db9eca2cdb329f38b3b-css";